
normal = perturbNormalArb( - vViewPosition, normal, vec2(dFdx(vDisplacement * 5.0), dFdy(vDisplacement * 5.0)), faceDirection * 1.0 );